import { JOB_CONFIGURATION_GET_COMMANDS } from "./constants";

export function scheduleGetTypeJob(newJobEntries, runGetJob) {
  const {
    jobName,
    jobType,
    selectedGroupOrMeters,
    configAction,
    cmdType,
    isActive,
    timeout,
    isCallBackEnabled,
    jobMeterCallback,
    jobCallback,
    jobCallbackUrl,
  } = newJobEntries || {};


  const selectedCommand = JOB_CONFIGURATION_GET_COMMANDS.find(cmnd => cmnd.id === cmdType)

  const payload = {
    jobName,
    jobType: configAction === "get" ? "METER_COMMAND_GET" : "METER_COMMAND_SET",
    jobConfiguration: {
      commands: [
        {
          type: selectedCommand["value"],
          active: isActive
        }
      ]
    },
    ...(selectedGroupOrMeters["name"] && { meterGroup: selectedGroupOrMeters["name"] }),
    ...(selectedGroupOrMeters["name"] === undefined && { meters: selectedGroupOrMeters }),
    ...(timeout && { timeoutTime: timeout.toISOString().replace('.000Z', 'Z') }),
    ...(isCallBackEnabled && {
      "callback": {
        "callbackOn": [
          jobMeterCallback && "JOB_METER_CALLBACK",
          jobCallback && "JOB_CALLBACK",
        ].filter(Boolean),
        "callbackUrl": jobCallbackUrl
      },
    }),
    startJob: true,
  }

  runGetJob(payload);

}